import React from "react";
import moment from "moment";
import { Tag } from "antd";

class StatusTag extends React.Component {
  render() {
    const { data } = this.props;
    let tag =
      data && data.user && data.user.attributes.currentSignInAt ? (
        <Tag color="green" key="active">
          Active
        </Tag>
      ) : (
        <Tag color="red" key="inactive">
          Inactive
        </Tag>
      );
    return data ? tag : null;
  }
}

export default StatusTag;



// WEBPACK FOOTER //
// ./src/pages/Patient/StatusTag.js